(() => {
  const STORAGE_KEY = 'recently_viewed';
  const MAX_ITEMS_DEFAULT = 8;

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  // ✅ pega o handle do jeito mais confiável
  function getHandleFromPage() {
    const fromBody = document.body?.getAttribute('data-product-handle');
    if (fromBody) return fromBody;

    // fallback (se por algum motivo o body não tiver)
    const canonical = document.querySelector('link[rel="canonical"]')?.href || '';
    const m = canonical.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // ✅ salva sempre que estiver em página de produto
  function saveCurrentProduct() {
    const handle = getHandleFromPage();
    if (!handle) return;

    let list = getList();
    list = list.filter((h) => h && h !== handle);
    list.unshift(handle);

    // limita
    list = list.slice(0, 20);
    setList(list);
  }

  async function renderSection() {
    const wrapper = document.querySelector('[data-recently-viewed]');
    if (!wrapper) return;

    const grid = wrapper.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    const limitAttr = wrapper.getAttribute('data-limit');
    const limit = limitAttr ? parseInt(limitAttr, 10) : MAX_ITEMS_DEFAULT;

    const list = getList().slice(0, limit);
    if (!list.length) return;

    const current = getHandleFromPage();
    const filtered = current ? list.filter((h) => h !== current) : list;

    if (!filtered.length) return;

    const htmlParts = [];

    for (const handle of filtered.slice(0, limit)) {
      try {
        const res = await fetch(`/products/${handle}?view=card`, { cache: 'no-store' });
        if (!res.ok) continue;

        const html = await res.text();
        htmlParts.push(html);
      } catch (e) {}
    }

    if (htmlParts.length) {
      grid.innerHTML = htmlParts.join('');
    }
  }

  // roda depois que a página carregou
  window.addEventListener('DOMContentLoaded', () => {
    saveCurrentProduct();
    renderSection();
  });
})();